module.exports = __webpack_public_path__ + "static/media/16a.91e6fae2.jpeg";